import React from 'react';

import SideBar from "../../containers/SideBar/SideBar.jsx";

import {Container} from "../../components/Container/Container";
import {CommonHeader} from "../../containers/CommonHeader/CommonHeader";


export const CommonLayout = ({children}) => {
    return <>
        <CommonHeader/>
        <SideBar/>
        <Container>
            {children}
        </Container>
    </>
}